import React from 'react';
import useIntersectCallback from '@nykaa/utils/IObserver/useIntersectCallback';


interface Props {
  loadMore: () => void;
  threshold: number;
}

function Observer({
  loadMore,
  threshold,
}: Props) {
  const [setNodeToObserve] = useIntersectCallback(
    {
      rootMargin: `0px 0px ${threshold}px 0px`,

    }, loadMore,
  );

  return (
    <div ref={setNodeToObserve} />
  );
}

export default Observer;
